// Per-app cookie scoping. The visitor's claimed code persists in a
// cookie named `<slug>_test_code` so they don't get a NEW code on each
// page reload. Scoped to the slug (not just the host) so a visitor
// can collect codes for multiple apps from the same browser without
// the cookies overwriting each other.
//
// 1-year expiry mirrors the elevator-simulator reference page.

const ONE_YEAR_SECS = 60 * 60 * 24 * 365;

export function readCode(slug: string): string | null {
  const name = `${slug}_test_code=`;
  for (const part of document.cookie.split(/;\s*/)) {
    if (part.startsWith(name)) {
      return decodeURIComponent(part.slice(name.length));
    }
  }
  return null;
}

export function writeCode(slug: string, code: string): void {
  const value = encodeURIComponent(code);
  document.cookie =
    `${slug}_test_code=${value}; path=/${encodeURIComponent(slug)}; ` +
    `max-age=${ONE_YEAR_SECS}; samesite=lax`;
}
